import { rpx } from 'client/lib/rpx-client';
import { DefaultSpinner } from '@components/spinner';
import { useAsyncData } from 'client/lib/hooks';
import type { MenuPane } from './types';
import type { CTAState } from 'server/types';
import { MenuHeader } from './core';
import { Button } from '@components/buttons';
import { useCurrentUser } from 'client/lib/auth';

export const EventTypePane: MenuPane<CTAState> = (props) => {
  const eventTypes = useAsyncData(rpx.ruzcalEventTypes.getEventTypesList, []);
  const user = useCurrentUser()!;

  return (
    <div class="flex flex-col min-h-80">
      <MenuHeader label="Booking link" close={props.close} />
      {eventTypes.isLoading && <DefaultSpinner />}
      {!eventTypes.isLoading && !eventTypes.data?.length && (
        <div class="text-gray-500">No event types found. Please create an event type first.</div>
      )}
      {!eventTypes.isLoading && !!eventTypes.data?.length && (
        <div class="flex flex-col gap-4">
          {eventTypes.data.map((x) => (
            <Button
              key={x.id}
              class="flex flex-col p-3 text-left rounded-lg border border-gray-200 hover:bg-gray-50 cursor-pointer"
              onClick={() => {
                const url = `/meet-direct/${user.id}/${x.id}`;
                props.setState((s) => ({
                  ...s,
                  url,
                  metadata: {
                    hostId: user.id,
                    eventTypeId: x.id,
                  },
                }));
                props.close();
              }}
            >
              <span class="font-medium">{x.name}</span>
              {x.description && <span class="text-sm text-gray-600 mt-1">{x.description}</span>}
              <span class="text-sm text-gray-500 mt-1">Duration: {x.duration} minutes</span>
            </Button>
          ))}
        </div>
      )}
    </div>
  );
};
